export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "questionnaire": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Questionnaires"])},
        "reports": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapports"])}
      },
      "en": {
        "questionnaire": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Questionnaires"])},
        "reports": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reports"])}
      }
    }
  })
}
